"use client"

import { useTranslations } from "next-intl"
import { ArticleCard } from "@/features/blog/components/article-card"
import type { BlogPost } from "@/shared/types/blog"
import type { UiLocale } from "@/shared/lib/i18n/config"

interface ArticleListProps {
  posts: BlogPost[]
  uiLocale: UiLocale
}

export function ArticleList({ posts, uiLocale }: ArticleListProps) {
  const t = useTranslations("blog.list")

  if (posts.length === 0) {
    return (
      <div className="py-20 text-center">
        <p className="text-lg font-medium text-[#9ca3af]">
          {t("emptyTitle")}
        </p>
        <p className="mt-1.5 text-[14px] text-[#d1d5db]">
          {t("emptyDescription")}
        </p>
      </div>
    )
  }

  const [featuredPost, ...remainingPosts] = posts

  return (
    <div>
      {featuredPost && (
        <ArticleCard
          key={`${featuredPost.locale}:${featuredPost.slug}`}
          post={featuredPost}
          uiLocale={uiLocale}
          variant="featured"
        />
      )}
      {remainingPosts.length > 0 && (
        <div className="blog-card-grid grid grid-cols-1 gap-10 sm:grid-cols-2 sm:gap-x-8 sm:gap-y-12 lg:grid-cols-3">
          {remainingPosts.map((post) => (
            <ArticleCard key={`${post.locale}:${post.slug}`} post={post} uiLocale={uiLocale} />
          ))}
        </div>
      )}
    </div>
  )
}
